import {refreshTokens} from "@/functions/authenticatedRequest";

const goToAccountManagement = (message = "") => {
	refreshTokens().then(() => {
		window.isIntentionalNavigation = true;
		let parameters = {
			'tp': sessionStorage.getItem('tp'),
			'thn': sessionStorage.getItem('thn'),
			'message': message
		}
		let redirectUrl = sessionStorage.getItem('redirectUrl')

		const form = document.createElement('form');
		form.method = 'POST';
		form.action = redirectUrl;
		document.body.appendChild(form);

		for (const key in parameters) {
			const formField = document.createElement('input');
			formField.type = 'hidden';
			formField.name = key;
			formField.value = parameters[key];
			form.appendChild(formField);
		}
		form.submit()
	});
}

export default goToAccountManagement